module.exports = __webpack_public_path__ + "img/gluten.1788c99c.svg";